//@ts-check
import { find, pickBy, isEmpty } from 'lodash-es';

// [BONUS] type & add `options` properties that passses along additional metadata (ex: tags)
export const manuallyActivatePage = (pageName: string) => {
  try {
    if (!window?.optimizely?.initialized) return;
    window?.optimizely.push({
      type: 'page',
      pageName,
    });
  } catch (err) {}
};
// ? [REVISIT] should we add manuallyActivateExperiment? how would we decide which `page` to activate?

export const getActiveVariations = (): VariationData[] => {
  try {
    if (!window?.optimizely?.initialized) return [];
    const optimizelyState = window?.optimizely?.get('state');
    if (!optimizelyState) return [];
    const variationMap: { [key: string]: NamedEntity } = optimizelyState?.getVariationMap();
    const activeExperimentIds = optimizelyState?.getActiveExperimentIds();
    const activeVariations = Object.entries(variationMap)
      .filter(([experimentId]) => activeExperimentIds.includes(experimentId))
      .map(([experimentId, variationData]) => ({
        variationId: variationData.id,
        variationName: variationData.name,
        experimentId,
      }));
    return activeVariations;
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const getActiveVariationIds = (): string[] => {
  try {
    const activeVariations = getActiveVariations();
    const activeVariationIds = activeVariations.map((variation) => variation.variationId);
    return activeVariationIds.sort((a, b) => Number(a) - Number(b));
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const findVariationData = (input: VariationLookupInput): VariationData | undefined => {
  try {
    const activeVariations = getActiveVariations();

    const parsedInput = pickBy(input);
    if (isEmpty(parsedInput)) return undefined;
    //@ts-ignore // ? [REVISIT] ts is isn't just  {variationId: string;variationName: string;experimentId: string;}
    return find(activeVariations, parsedInput);
  } catch (err) {
    return undefined;
  }
};

const isExperimentActive = (experimentId: string) => {
  try {
    if (!window?.optimizely) return false;
    const activeIds: string[] = window.optimizely.get('state').getActiveExperimentIds();
    return activeIds.includes(experimentId);
  } catch (error) {
    console.error(error);
    return false;
  }
};

export const checkIfInVariation = (input: VariationLookupInput): boolean => {
  if (!isExperimentActive(input.experimentId)) return false;
  const match = findVariationData(input);
  const isInVariation = !!match;
  return !!isInVariation;
};

export const manualActivationCheckIfInVariation = ({
  experimentId,
  variationId,
  pageName,
}: {
  experimentId: string;
  variationId: string;
  pageName: string;
}) => {
  const isAlreadyInBucket = checkIfInVariation({ experimentId });
  if (!isAlreadyInBucket) manuallyActivatePage(pageName);
  return checkIfInVariation({ experimentId, variationId });
};

export const getExperimentData = (experimentId: string) => {
  try {
    if (!window?.optimizely?.initialized) return null;
    const experimentStates: { [key: string]: ExperimentStateObject | undefined } = window?.optimizely
      .get('state')
      .getExperimentStates({
        // ? [REVISIT] (semantically) what is a 'decision' / what does it represent?
        decision: { experimentId },
        isActive: true,
      });
    const relevantExperiment = experimentStates[experimentId];
    return relevantExperiment;
  } catch (err) {
    return null;
  }
};

// Types
export type VariationData = {
  variationId: string;
  variationName: string;
  experimentId: string;
};
export type VariationLookupInput = { variationId?: string; experimentId: string; variationName?: string };

export interface ExperimentStateObject {
  audiences: NamedEntity[];
  variation: NamedEntity;
  visitorRedirected: boolean;
  isActive: boolean;
  id: string;
  experimentName: string;
  isInExperimentHoldback: boolean;
}

export interface NamedEntity {
  id: string;
  name: string;
}
